import { useState, useCallback } from 'react'
import { SchoolLookUpSiteData } from 'types'

interface AdminData {
  email: string
  confirmEmail: string
}

interface ConfirmData {
  isConfirmed: boolean
}

export const Steps = {
  School: 1,
  LicenseAdmin: 2,
  Confirm: 3,
}

export const useAssignFormState = (defaultAdminEmail?: string) => {
  const [activeTab, setActiveTab] = useState(Steps.School)
  const [isStepValid, setIsStepValid] = useState(false)

  // Step data - all fields start blank for user selection
  const [schoolData, setSchoolData] = useState<SchoolLookUpSiteData>({
    city: '',
    companyName: '',
    country: '',
    netsuiteCustomerId: null,
    nsCustomerId: '',
    organizationName: '',
    region: '',
  })
  const [email, setEmail] = useState(defaultAdminEmail || '')
  const [confirmEmail, setConfirmEmail] = useState('')
  const [isConfirmed, setIsConfirmed] = useState(false)

  const handleStep = useCallback(
    (data: SchoolLookUpSiteData | AdminData | ConfirmData) => {
      if (activeTab === Steps.School) {
        const schoolLookupData = data as SchoolLookUpSiteData
        setSchoolData(schoolLookupData)
      } else if (activeTab === Steps.LicenseAdmin) {
        const adminData = data as AdminData
        setEmail(adminData.email)
        setConfirmEmail(adminData.confirmEmail)
      } else if (activeTab === Steps.Confirm) {
        const confirmData = data as ConfirmData
        setIsConfirmed(confirmData.isConfirmed)
      }
    },
    [activeTab],
  )

  const goBack = useCallback(() => {
    const newTab = activeTab - 1
    setActiveTab(newTab)
    setIsStepValid(false)
  }, [activeTab])

  const goNext = useCallback(() => {
    const newTab = activeTab + 1
    setActiveTab(newTab)
    setIsStepValid(false)
  }, [activeTab])

  return {
    activeTab,
    setActiveTab,
    isStepValid,
    setIsStepValid,
    schoolData,
    email,
    confirmEmail,
    isConfirmed,
    handleStep,
    goBack,
    goNext,
  }
}
